import React, {Component} from 'react';

const EmptyCart = (props) =>{
  return(
    <div className="container-fluid">
      <center>
        <div className="empty-cart"></div>
        <h4>Здесь пока пусто...</h4>
      </center>
    </div>
  )
};

export default EmptyCart;
